// extracted by mini-css-extract-plugin
export default {"container":"Badge_container__G6Fjs"};